import {
    Component,
    OnChanges,
    OnInit,
    Input,
    NgModule,
    NgModuleFactory,
    Compiler,
    SimpleChanges
} from '@angular/core';

import { SharedStageComponentsModule } from '../../containers/sharedComponents.module';
import { IDynamicData } from '../../../shared/types/dynamicData';
import { Observable } from 'rxjs/Rx';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'tr-dynamic',
  templateUrl: './dynamic.component.html',
  //styleUrls: ['./dynamic.component.scss']
})
export class DynamicComponent {

  dynamicComponent: any;
  dynamicModule: NgModuleFactory<any>;

  @Input('html') html: string;
  @Input() entity$: Observable<IDynamicData>;
  @Input() additional$: Observable<IDynamicData>;

  constructor( private compiler: Compiler ) { }

  ngOnChanges(changes: SimpleChanges) {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add 'implements OnChanges' to the class.
    if (changes['html'] && !changes['html'].isFirstChange()) {
      this.dynamicComponent = this.createNewComponent(this.html, this.entity$, this.additional$);
      this.dynamicModule = this.compiler.compileModuleSync(this.createComponentModule(this.dynamicComponent));
    }
  }

  ngOnInit() {
    this.dynamicComponent = this.createNewComponent(this.html, this.entity$, this.additional$);
    this.dynamicModule = this.compiler.compileModuleSync(this.createComponentModule(this.dynamicComponent));
  }

  protected createComponentModule(componentType: any) {
    @NgModule({
      imports: [ SharedStageComponentsModule ],
      declarations: [
        componentType
      ],
      entryComponents: [componentType]
    })
    class RuntimeComponentModule {}

    // a module for just this Type
    return RuntimeComponentModule;
  }

  protected createNewComponent(template: string, entity$: Observable<IDynamicData>, additional$: Observable<IDynamicData>) {
    @Component({
      selector: 'tr-dynamic-component',
      template: template ? template : '<div></div>'
    })
    class TrDynamicComponent implements OnInit, OnDestroy {
      entity: IDynamicData;
      additional: IDynamicData;
      sub: Array<Subscription> = [];
      constructor() { }

      ngOnInit() {
        this.sub.push( 
          entity$.subscribe( (en) => this.entity = en),
          additional$.subscribe( (add) => this.additional = add)
        )
      }

      ngOnDestroy() {
        this.sub.forEach(_sub => _sub.unsubscribe());
      }
    }

    return TrDynamicComponent;
  }
}



// WEBPACK FOOTER //
// ./src/app/stage/components/dynamic/dynamic.component.ts